import React from 'react';

import { ModalProps } from './Modal.props';
import { StyledModal } from './Modal.styles';

export const Modal: React.FC<ModalProps> = ({
  open,
  children,
  disableAutoFocus = false,
  onClose
}) => {
  return (
    <StyledModal disablePortal open={open} onClose={(event, reason) => onClose?.(event, reason)} disableAutoFocus={disableAutoFocus}>
      {children}
    </StyledModal>
  );
};